import { useEffect, useState } from 'react';
import { fetchPaymentStatus, CancelOriginalPlan } from '../api/payment'
import { findOriginalPlan } from '../api/user';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';

const Complete = () => {
  const [campaignCode, setCampaignCode] = useState('');
  const [linkageIdentifier, setLinkageIdentifier] = useState('');
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const status = location.state?.status || 'payment';

  useEffect(() => {
    const handlePayment = async () => {
      const sessionId = searchParams.get('session_id');
      if (!sessionId) {
        console.error('session_id がURLに存在しません');
        return;
      }

      try {
        // 支払い情報取得
        const data = await fetchPaymentStatus(sessionId);
        const priceId = data.price_id || '';
        const campaign = data.campaign_code || '';
        const linkage = data.linkage_identifier || '';
        setCampaignCode(campaign);
        setLinkageIdentifier(linkage);

        const res = await findOriginalPlan(priceId);
        const originalPlan = res.original_plan;

        if(originalPlan?.plan?.upgrade_type === 2){
          await CancelOriginalPlan(priceId);
        }

        // docomo連携用POSTフォーム作成
        const baseUrl = process.env.REACT_APP_REDIRECT_URL;
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = baseUrl;

        form.style.display = 'none';

        const campaignInput = document.createElement('input');
        campaignInput.type = 'hidden';
        campaignInput.name = 'campaign_code';
        campaignInput.value = campaign;

        const linkageInput = document.createElement('input');
        linkageInput.type = 'hidden';
        linkageInput.name = 'linkage_identifier';
        linkageInput.value = linkage;

        form.appendChild(campaignInput);
        form.appendChild(linkageInput);
        document.body.appendChild(form);

        console.log('3秒後にシリアルコード配布サイトへ遷移します');

        const timer = setTimeout(() => {
          form.submit();
        }, 3000);

        return () => clearTimeout(timer);
      } catch (err) {
        console.error('API取得エラー:', err);
      }
    };

    handlePayment();
  }, [searchParams]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 5,
          maxWidth: 500,
          width: '100%',
          borderRadius: 2,
        }}
      >
        <Typography variant="h4" color="success.main">
          {status === 'cancel' ? '解約完了しました。' : '決済完了しました。'}
        </Typography>

        <Box sx={{ my: 3, overflowWrap: 'break-word' }}>
          {linkageIdentifier && (
            <Typography variant="body1">
              決済番号: {linkageIdentifier}
            </Typography>
          )}
        </Box>

        <Box sx={{ mt: 3 }}>
          <CircularProgress size={40} sx={{ mb: 2 }} />
          <Typography variant="body1" color="text.secondary">
            3秒後にシリアルコード配布サイトへ遷移します...
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default Complete;
